import { render, staticRenderFns } from "./base-form-item.vue?vue&type=template&id=634605a8"
import script from "./base-form-item.vue?vue&type=script&lang=js"
export * from "./base-form-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports